import { render } from "./ObjectView.vue?vue&type=template&id=6b070bf8"
import script from "./ObjectView.vue?vue&type=script&lang=js"
export * from "./ObjectView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__